import React from 'react';
import { Link } from 'react-router-dom';

const Home = () => {
  return (
    <section>
      <h2>Welcome to Dream College Path</h2>
      <p>
        <b>Dream College Path</b> is a comprehensive platform designed to empower high school students on their journey to college. Whether you’re aiming for your dream school or exploring various options, we provide the tools and resources to help you navigate the college admissions process with confidence. From discovering the best colleges for your academic and personal goals to preparing standout applications, we’ve got you covered.
      </p>
      <p>
        One of the core features of Dream College Path is our <b>Extracurricular Project Builder</b>. We understand that colleges today are looking for more than just good grades—they want to see students with passion and initiative. That’s why we help you identify your unique interests and guide you in creating personalized projects that showcase your skills, leadership, and creativity. Whether you’re passionate about technology, social causes, science, or the arts, we’ll provide ideas and resources to help you develop meaningful projects that stand out on your college applications.
      </p>
      <p>
        We invite you to participate in our <b>Student Questionnaire</b> where you can choose your area of interest and explore exciting project opportunities. Let us know what excites you, and we’ll guide you toward building something extraordinary. To get started or if you have any questions, feel free to <b>contact us</b> anytime. We’re here to support your college journey!
      </p>
      <div className="cta-buttons">
        <Link to="/sign-up">Sign Up Now</Link>
        {/* <Link to="/tutoring-service">
          Tutoring Service
          <p style={{ textAlign: 'center' }}>DS Data Science, CS Computer Science</p>
        </Link> */}
        <Link to="/login">Login</Link>
      </div>
    </section>
  );
};

export default Home;
